import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { countOfRecourd } from '../../Shared/utils/helper';
/** @format */
import Master from '../Layouts/Master';

const MyEvents = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getEvents();
  }, [search]);
  const getEvents = async () => {
    setLoading(true);
    await useApi.get(
      `/user/event${search}`,
      {},
      (res) => {
        eventContext.events = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            رویدادهای ثبت نامی
          </h1>
        </div>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.events?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>شروع</th>
                <th>پایان</th>
                <th>مشاهده نفرات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.events?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {countOfRecourd(
                      index,
                      eventContext.events?.meta?.pagination?.per_page,
                      eventContext.events?.meta?.pagination?.current_page,
                    )}
                  </th>
                  <td>{item.title}</td>
                  <td>
                    {moment(
                      item.start_register_date ?? '1999-01-01 00:00:00',
                      'YYYY-MM-DD HH:mm:ss',
                    )
                      .locale('fa')
                      .format('YYYY-MM-DD')}
                  </td>
                  <td>
                    {moment(
                      item.end_register_date ?? '1999-01-01 00:00:00',
                      'YYYY-MM-DD HH:mm:ss',
                    )
                      .locale('fa')
                      .format('YYYY-MM-DD')}
                  </td>
                  <td>
                    {item.type !== 1 ? (
                      <Link
                        to={
                          item.type !== 1 &&
                          `/panel/user/event/${item?.id}/team`
                        }
                        target='_blank'
                        className='btn btn-info btn-sm d-flex flex-row justify-content-center p-2'
                      >
                        <i className='fad fa-eye text-dark-mode f-15'></i>
                      </Link>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              رویدادی که برای دیگران ثبت‌نام کرده‌اید وجود ندارد
            </span>
          </div>
        )}
      </div>

      <div className='w-100 mt-4 d-flex'>
        <Pagination
          search={search}
          totalPage={eventContext.events?.meta?.pagination?.total_pages}
          basePath='/panel/user/event'
        />
      </div>
    </Master>
  );
};

export default MyEvents;
